import Link from 'next/link';
import type { PopularLinks } from '~/services/job-search/fetch-jobs';

interface PopularLinksProps {
  popularLinks: PopularLinks;
}

export function PopularLinks(props: PopularLinksProps) {
  return (
    <div>
      <h2 className="text-sm md:text-base">{props.popularLinks.title}</h2>
      <div className="p-job-search__keywords mt-1 u-pb6">
        {props.popularLinks.links.map((link) => (
          // 動的な求人一覧リンク(/jobs/search?...)が渡ってくることはないためaタグではなくLinkを使用する
          <Link
            key={link.name}
            className="c-keyword -bordered -nowrap !m-0 leading-none"
            href={link.link}
            prefetch={false}
          >
            {link.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
